import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'common/components/modal-full';
import defaultStyles from 'commonStyles/components/coupon/_loyalty';
import styleOverrides from 'styles/components/coupon/_loyalty';
import useStyleOverrides from 'common/components/hooks/use-style-overrides';
import { translate } from 'common/localization';
import BcsCloseIcon from 'bcs/icons/close';

const LoyaltyCouponRestrictions = (props) => {
  const { restrictions, isOpen, onExitModal } = props;
  const { title, items } = restrictions;
  const styles = useStyleOverrides(defaultStyles, styleOverrides);

  return (
    <Modal
      id="loyaltyCouponBannerRestrictions"
      modalTitle={title}
      showModal={isOpen}
      firstFocusElement="span"
      onExitFn={onExitModal}
      onBackgroundClick={onExitModal}
      onEscapeKey={onExitModal}
      modalContentClass={styles.modalContentClass}
    >
      <button className={`btn-reset ${styles.closeBtn}`} onClick={onExitModal}>
        <BcsCloseIcon />
        <span className="visually-hidden">{translate('label.coupon.banner.close')}</span>
      </button>
      <div className={styles.restrictionsModal}>
        <h2 className={styles.restrictionsTitle}>{title}</h2>
        {items.map(({ title: pointTitle, points }) => (
          <div key={`loyalty-coupon-restrictions-${pointTitle}`}>
            <h3 className={styles.restrictionsSubTitle}>{pointTitle}</h3>
            <ul className={styles.restrictionsList}>
              {points.map(point => <li key={point} className={styles.restrictionsListItem}>{point}</li>)}
            </ul>
          </div>
        ))}
      </div>
    </Modal>
  );
};

LoyaltyCouponRestrictions.propTypes = {
  restrictions: PropTypes.shape({
    title: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      points: PropTypes.arrayOf(PropTypes.string),
    })).isRequired,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onExitModal: PropTypes.func.isRequired,
};

export default LoyaltyCouponRestrictions;
